import React, { useEffect } from 'react';
import { Container, lighten, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';
import { selectedDps } from '../../atoms/DspState';
import ListHeader from '../../components/ListHeader';
import Pagination from '../../components/Pagination';
import { dspAtom, dspDrivers } from '../../reducers/DspReducer';
import { getDrivers } from '../../repositories/HttpRepository';
import SearchForm from './SearchForm';
import { AxlButton } from 'components/AxlButton';

const fields = [
  {
    id: 'dsp_id',
    numeric: false,
    disablePadding: true,
    label: 'id',
    isDisableSort: true,
  },
  {
    id: 'company',
    numeric: false,
    disablePadding: false,
    label: 'Company Name',
    isDisableSort: true,
  },
  {
    id: 'alias',
    numeric: false,
    disablePadding: false,
    label: 'Alias',
    isDisableSort: true,
  },
  { id: 'id', numeric: false, disablePadding: false, label: 'Driver ID' },
  {
    id: 'first_name_last_name',
    numeric: false,
    disablePadding: false,
    label: 'Driver Name',
    isDisableSort: true,
  },
  { id: 'email', numeric: false, disablePadding: false, label: 'Email' },
  {
    id: 'phone_number',
    numeric: false,
    disablePadding: false,
    label: 'Phone Number',
  },
];

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0eb',
  },
  table: {
    minWidth: 750,
    '& tr th:nth-of-type(-n+3)': {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    },
    '& tr td:nth-of-type(-n+3)': {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    marginBottom: '10px',
  },
  cellOnClick: {
    '&>a': {
      color: '#4a90e2',
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  searchBtn: {
    backgroundColor: '#75c31e',
  },
}));
const ListDspDriver = () => {
  const [state, updateValues] = useRecoilState(dspDrivers);
  const resetDspState = useResetRecoilState(dspAtom);
  const resetDspDriverState = useResetRecoilState(dspDrivers);
  const [dspState, updateDspState] = useRecoilState(dspAtom);
  const navigate = useNavigate();
  const updateSelectDsp = useSetRecoilState(selectedDps);
  const { items, page, size, desc, order_by, total, isListing, q } = state;
  const { classes } = useStyles();
  const getList = (params) => {
    let queryParams = { page, size, q };
    if (params) queryParams = { ...queryParams, ...params };

    getDrivers(queryParams).then((resp) => {
      if (resp.ok) {
        const data = resp.data;
        updateValues({
          ...state,
          ...queryParams,
          total: data.total,
          size: data.size,
          items: data.items,
        });
      }
    });
  };

  useEffect(() => {
    getList();
  }, [q]);

  const handleRequestSort = (event, property) => {
    const isDesc = order_by === property && desc;
    getList({ page: page, order_by: property, desc: !isDesc, q: q });
  };
  const handleChangePage = (event, newPage) => {
    getList({ page: newPage - 1, order_by, desc, q: q });
  };

  const addAction = (e) => {
    e.preventDefault();
    navigate('/dsp/add');
  };

  function linkToDsp(dspID) {
    updateDspState({
      ...dspState,
      q: 'id:' + dspID,
    });
    window.setTimeout(() => {
      navigate('/dsp');
    }, 10);
  }

  return (
    <Container maxWidth={false}>
      <div className={classes.buttonWrapper}>
        <AxlButton variant="contained" color="primary" onClick={addAction} className={classes.searchBtn}>
          + NEW
        </AxlButton>
      </div>
      <SearchForm getList={getList} updateValues={updateValues} placeholder="Search for DSP drivers by driver name, driver ID…" />
      <Paper className={classes.paper}>
        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table" key="dsp-drivers-table">
            <ListHeader fields={fields} desc={desc} orderBy={order_by} onRequestOrder={handleRequestSort} rowCount={items.length} />
            <TableBody>
              {items.map((item, index) => {
                const labelId = `dsp-table-item-${index}`;
                return (
                  <TableRow hover tabIndex={-1} key={`dsp-driver-${index}`}>
                    <TableCell id={labelId} scope="row" onClick={(e) => (item.courier != null ? linkToDsp(item.courier.id) : '')}>
                      {item.courier.id}
                    </TableCell>
                    <TableCell onClick={(e) => (item.courier != null ? linkToDsp(item.courier.id) : '')}>{item.courier.company}</TableCell>
                    <TableCell onClick={(e) => (item.courier != null ? linkToDsp(item.courier.id) : '')}>{item.courier.code}</TableCell>
                    <TableCell>{item.driver.id}</TableCell>
                    <TableCell>
                      {item.driver.first_name} {item.driver.last_name}
                    </TableCell>
                    <TableCell>{item.driver.email}</TableCell>
                    <TableCell>{item.driver.phone_number}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          {isListing && <LinearProgress />}
        </TableContainer>
        <Pagination total={total} size={size} onChange={handleChangePage} />
      </Paper>
    </Container>
  );
};
export default React.memo(ListDspDriver);
